<ng-template #content>
  <app-message [service]="messageService"></app-message>
  <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)" *ngIf="formCreated">
    <table class="table w-100">
      <tbody>
        <tr>
          <th></th>
          <th i18n="@@subscriptionTypeBasicLabel">Basic</th>
          <th i18n="@@subscriptionTypeStandardLabel">Standard</th>
          <th i18n="@@subscriptionTypePremiumLabel">Premium</th>
        </tr>

        <tr>
          <td i18n="@@FeaturesNavigation">Features Navigation</td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@NaviDashBoard">Navi - Dashboard</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="navDashboard_basic" formControlName="navDashboard">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="navDashboard_stadard" formControlName="navDashboard">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="navDashboard_premium" formControlName="navDashboard">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@NaviChargingStation">Navi - Ladestationen</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="navChargingstations_basic" formControlName="navChargingstations">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="navChargingstations_standard" formControlName="navChargingstations">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="navChargingstations_premium" formControlName="navChargingstations">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@NaviEvaluation">Navi - Auswertung</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="navEvaluation_basic" formControlName="navEvaluation">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="navEvaluation_standard" formControlName="navEvaluation">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="navEvaluation_premium" formControlName="navEvaluation">
            </div>
          </td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@NaviManagement">Navi - Verwaltung</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="navManage_basic" formControlName="navManage">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="navManage_standard" formControlName="navManage">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="navManage_premium" formControlName="navManage">
            </div>
          </td>
        </tr>

        <tr>
          <td i18n="@@FeatureDashBoard">Features Dashboard</td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@WidgetChargingstations">Widget Ladestationen</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="dashboardChargingstations_basic" formControlName="dashboardChargingstations">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="dashboardChargingstations_standard" formControlName="dashboardChargingstations">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="dashboardChargingstations_premium" formControlName="dashboardChargingstations">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@WidgetConsumptionPowerChart">Widget Verbrauch</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchart_basic" formControlName="dashboardPowerchart">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchart_standard" formControlName="dashboardPowerchart">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchart_premium" formControlName="dashboardPowerchart">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@WidgetNewTransaction">Widget Neuste Ladevorgänge</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="dashboardLatestTransactions_basic" formControlName="dashboardLatestTransactions">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="dashboardLatestTransactions_standard" formControlName="dashboardLatestTransactions">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="dashboardLatestTransactions_premium" formControlName="dashboardLatestTransactions">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@WidgetProfile">Widget Profil</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="dashboardProfile_basic" formControlName="dashboardProfile">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="dashboardProfile_standard" formControlName="dashboardProfile">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="dashboardProfile_premium" formControlName="dashboardProfile">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@WidgetCO2">Widget CO<sub>2</sub> Ersparnis</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="dashboardCo2_basic" formControlName="dashboardCo2">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="dashboardCo2_standard" formControlName="dashboardCo2">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="dashboardCo2_premium" formControlName="dashboardCo2">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@PowerChartDailyView">Verbrauch Dropdown - Tag Ansicht</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchartDay_basic" formControlName="dashboardPowerchartDay">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchartDay_standard" formControlName="dashboardPowerchartDay">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchartDay_premium" formControlName="dashboardPowerchartDay">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@PowerChartMonthlyView">Verbrauch Dropdown - Monat Ansicht</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchartMonth_basic" formControlName="dashboardPowerchartMonth">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchartMonth_standard" formControlName="dashboardPowerchartMonth">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchartMonth_premium" formControlName="dashboardPowerchartMonth">
            </div>
          </td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@PowerCharYearlyView">Verbrauch Dropdown - Jahr Ansicht</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchartYear_basic" formControlName="dashboardPowerchartYear">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchartYear_standard" formControlName="dashboardPowerchartYear">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="dashboardPowerchartYear_premium" formControlName="dashboardPowerchartYear">
            </div>
          </td>
        </tr>

        <tr>
          <td i18n="@@FeatureChargingstations">Features Ladestationen</td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@TabChargingGroups">Reiter Ladestationsgruppen</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="chargingstationsGroups_basic" formControlName="chargingstationsGroups">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="chargingstationsGroups_standard" formControlName="chargingstationsGroups">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="chargingstationsGroups_premium" formControlName="chargingstationsGroups">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@AddChargingStations">Ladestationen hinzufügen</strong>
          </th>
          <td>
            <div class="form-group row" formGroupName="basic">
              <div class="col-lg-5">
                <input class="form-control" type="number" id="chargingstationsCreate_basic" formControlName="chargingstationsCreate">
              </div>
            </div>
          </td>
          <td>
            <div class="form-group row" formGroupName="standard">
              <div class="col-lg-5">
                <input class="form-control" type="number" id="chargingstationsCreate_standard" formControlName="chargingstationsCreate">
              </div>
            </div>
          </td>
          <td>
            <div class="form-group row" formGroupName="premium">
              <div class="col-lg-5">
                <input class="form-control" type="number" id="chargingstationsCreate_premium" formControlName="chargingstationsCreate">
              </div>
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@DetailsOverviewTabAuthorization">Detailansicht - Reiter Autorisierung</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="chargingstationDetailsAuth_basic" formControlName="chargingstationDetailsAuth">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="chargingstationDetailsAuth_standard" formControlName="chargingstationDetailsAuth">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="chargingstationDetailsAuth_premium" formControlName="chargingstationDetailsAuth">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@DetailsOverviewTabTransactions">Detailansicht - Reiter Ladeprotokoll</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="chargingstationDetailsTransactions_basic" formControlName="chargingstationDetailsTransactions">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="chargingstationDetailsTransactions_standard" formControlName="chargingstationDetailsTransactions">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="chargingstationDetailsTransactions_premium" formControlName="chargingstationDetailsTransactions">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@FreeChargeMode">FreeCharge Mode</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="chargingstationFreecharge_basic" formControlName="chargingstationFreecharge">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="chargingstationFreecharge_standard" formControlName="chargingstationFreecharge">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="chargingstationFreecharge_premium" formControlName="chargingstationFreecharge">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@TransactionRemoteStart">Ladevorgang freigeben</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="chargingstationRemoteStart_basic" formControlName="chargingstationRemoteStart">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="chargingstationRemoteStart_standard" formControlName="chargingstationRemoteStart">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="chargingstationRemoteStart_premium" formControlName="chargingstationRemoteStart">
            </div>
          </td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@AddChargingGroups">Gruppen hinzufügen</strong>
          </th>
          <td>
            <div class="form-group row" formGroupName="basic">
              <div class="col-lg-5">
                <input class="form-control" type="number" id="chargingstationGroupsCreate_basic" formControlName="chargingstationGroupsCreate">
              </div>
            </div>
          </td>
          <td>
            <div class="form-group row" formGroupName="standard">
              <div class="col-lg-5">
                <input class="form-control" type="number" id="chargingstationGroupsCreate_standard" formControlName="chargingstationGroupsCreate">
              </div>
            </div>
          </td>
          <td>
            <div class="form-group row" formGroupName="premium">
              <div class="col-lg-5">
                <input class="form-control" type="number" id="chargingstationGroupsCreate_premium" formControlName="chargingstationGroupsCreate">
              </div>
            </div>
          </td>
        </tr>

        <tr>
          <td i18n="@@FeaturesEvaluation">Features Auswertung</td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@TabTransactions">Reiter Ladevorgänge</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="evaluationTransactions_basic" formControlName="evaluationTransactions">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="evaluationTransactions_standard" formControlName="evaluationTransactions">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="evaluationTransactions_premium" formControlName="evaluationTransactions">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@TabDeliverynotes">Reiter Lieferscheine</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="evaluationDeliveryNotes_basic" formControlName="evaluationDeliveryNotes">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="evaluationDeliveryNotes_standard" formControlName="evaluationDeliveryNotes">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="evaluationDeliveryNotes_premium" formControlName="evaluationDeliveryNotes">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@ChargingStatisticsWeeklyView">Ladestatistik - Wochen Ansicht</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsWeek_basic" formControlName="chargingStatisticsWeek">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsWeek_standard" formControlName="chargingStatisticsWeek">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsWeek_premium" formControlName="chargingStatisticsWeek">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@ChargingStatisticsMonthlyView">Ladestatistik - Monat Ansicht</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsMonth_basic" formControlName="chargingStatisticsMonth">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsMonth_standard" formControlName="chargingStatisticsMonth">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsMonth_premium" formControlName="chargingStatisticsMonth">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@ChargingStatisticsYearlyView">Ladestatistik - Jahr Ansicht</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsYear_basic" formControlName="chargingStatisticsYear">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsYear_standard" formControlName="chargingStatisticsYear">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsYear_premium" formControlName="chargingStatisticsYear">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@ChargingStatisticsCustomizedView">Ladestatistik - Zeitraum wählbar</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsCustom_basic" formControlName="chargingStatisticsCustom">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsCustom_standard" formControlName="chargingStatisticsCustom">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsCustom_premium" formControlName="chargingStatisticsCustom">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@ChargingStatisticsFilter">Ladestatistik - Filter (Dropdownfelder)</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsFilter_basic" formControlName="chargingStatisticsFilter">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsFilter_standard" formControlName="chargingStatisticsFilter">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsFilter_premium" formControlName="chargingStatisticsFilter">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@ChargingStatisticsCheckbox">Ladestatistik - Checkboxen</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsCheckbox_basic" formControlName="chargingStatisticsCheckbox">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsCheckbox_standard" formControlName="chargingStatisticsCheckbox">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsCheckbox_premium" formControlName="chargingStatisticsCheckbox">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@ChargingStatisticsDateFilter">Ladestatistik - Datumsfilter (Auswahl des Zeitraumes)</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsDateFilter_basic" formControlName="chargingStatisticsDateFilter">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsDateFilter_standard" formControlName="chargingStatisticsDateFilter">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="chargingStatisticsDateFilter_premium" formControlName="chargingStatisticsDateFilter">
            </div>
          </td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@DeliveryNotesSendOptions">Lieferscheine - Versandt Option</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="evaluationDeliveryNotesSend_basic" formControlName="evaluationDeliveryNotesSend">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="evaluationDeliveryNotesSend_standard" formControlName="evaluationDeliveryNotesSend">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="evaluationDeliveryNotesSend_premium" formControlName="evaluationDeliveryNotesSend">
            </div>
          </td>
        </tr>

        <tr>
          <td i18n="@@FeaturesManagement">Features Verwaltung</td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@AddUsers">Benutzer - Benutzer hinzufügen</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="manageUsersCreate_basic" formControlName="manageUsersCreate">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="manageUsersCreate_standard" formControlName="manageUsersCreate">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="manageUsersCreate_premium" formControlName="manageUsersCreate">
            </div>
          </td>
        </tr>

        <tr class="form-group noBorder">
          <th>
            <strong i18n="@@UsersCount">Benutzer - Anzahl Benutzer</strong>
          </th>
          <td>
            <div class="form-group row" formGroupName="basic">
              <div class="col-lg-5">
                <input class="form-control" type="number" id="manageUsersCreateCount_basic" formControlName="manageUsersCreateCount">
              </div>
            </div>
          </td>
          <td>
            <div class="form-group row" formGroupName="standard">
              <div class="col-lg-5">
                <input class="form-control" type="number" id="manageUsersCreateCount_standard" formControlName="manageUsersCreateCount">
              </div>
            </div>
          </td>
          <td>
            <div class="form-group row" formGroupName="premium">
              <div class="col-lg-5">
                <input class="form-control" type="number" id="manageUsersCreateCount_premium" formControlName="manageUsersCreateCount">
              </div>
            </div>
          </td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@RfidCardScan">RFID-Karten anlernen</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="manageRfidScan_basic" formControlName="manageRfidScan">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="manageRfidScan_standard" formControlName="manageRfidScan">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="manageRfidScan_premium" formControlName="manageRfidScan">
            </div>
          </td>
        </tr>

        <tr class="form-group">
          <th>
            <strong i18n="@@CreateIndividualDeliveryNote">Individuelle Lieferscheine erstellen</strong>
          </th>
          <td>
            <div class="form-check" formGroupName="basic">
              <input class="form-check-input" type="checkbox" id="createDeliveryNotes_basic" formControlName="createDeliveryNotes">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="standard">
              <input class="form-check-input" type="checkbox" id="createDeliveryNotes_standard" formControlName="createDeliveryNotes">
            </div>
          </td>
          <td>
            <div class="form-check" formGroupName="premium">
              <input class="form-check-input" type="checkbox" id="createDeliveryNotes_premium" formControlName="createDeliveryNotes">
            </div>
          </td>
        </tr>

      </tbody>
    </table>
    <div class="float-end">
      <button type="submit" id="save_changes" class="btn btn-yellow" [disabled]="!(formService.form.valid && formService.form.dirty)" i18n="@@SaveChangesButton">Änderung speichern</button>
    </div>
  </form>
</ng-template>

<!-- <main class="flex-shrink-0">
  <div class="container-fluid">
    <div class="row mt-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header card-title">
            <h5 i18n="@@CustomerPermissionsHeader">Abonnement - Featurezuweisung</h5>
          </div>

          <div class="card-body">
            <ng-container *ngTemplateOutlet="content"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</main> -->

<main id="subscription-types">
  <div class="card">
    <div class="card-header card-title">
      <h5 i18n="@@CustomerPermissionsHeader"><app-svg source="icons/feather/check-square" height="18" class="me-2"></app-svg>Abonnement - Featurezuweisung</h5>
    </div>

    <div class="card-body">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </div>
</main>
